import { getTitle } from '../helpers';
import { getCommonProps } from '../helpers/commonHelpers';

export const prepareCardData = cardData => {
  const sectionHeadline = getTitle(cardData);
  const maxResults = cardData?.properties?.custom?.maxResults;

  return {
    ...getCommonProps(cardData),
    carouselId: 'ciclp.top-trending',
    maxResults,
    sectionHeadline,
  };
};

export const getUrlIngredients = () => [];
